<template>
  <v-container>
    <v-stepper v-model="e1">
      <v-card class="lime elevation-0 rounded-0" dark tile>
        <v-card-title>
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <h3 style="color:white">
            KNDI ATRI & ACREPHAP Grant Writing Needs Assessment
          </h3>
        </v-card-title>
      </v-card>
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
          color="lime"
          v-if="step_one == true"
        ></v-stepper-step>
        <v-stepper-step
          :complete="e1 > 1"
          :rules="[() => false]"
          step="1"
          v-else-if="step_one == false"
        >
          Error
          <small>please correct</small>
        </v-stepper-step>

        <!--<template v-for="upload in uploads">
          <v-stepper-step :complete="e1 > upload.step" :step="upload.step" editable></v-stepper-step>

          <v-divider v-if="upload.step !== uploads" :key="upload.step"></v-divider>
        </template>-->
      </v-stepper-header>
      <v-stepper-items>
        <v-snackbar v-model="snackbar" :multi-line="mode" :right="x" :top="y">
          {{ snackbar_text }}
          <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-stepper-content step="1">
          <form @submit.prevent="StepOne">
            <v-card class="mb-5" color="grey lighten-4" height flat>
              <v-card-text>
                <v-flex xs12 md12>
                  <h4>Interviewee Name</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.name"
                    :error-messages="errors.name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Email</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.email"
                    :error-messages="errors.email"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Have you won any grants before?</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-radio-group
                    v-model="register.grant_history"
                    wrap
                    :error-messages="errors.grant_history"
                  >
                    <v-radio label="Yes" value="Yes" color="lime"></v-radio>
                    <v-radio label="No" value="No" color="lime"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <h4>If yes, haw many?</h4>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.grant_number"
                    :error-messages="errors.grant_number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <h4>If yes, how long ago?</h4>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <v-radio-group
                    v-model="register.grant_last"
                    wrap
                    :error-messages="errors.grant_last"
                  >
                    <v-radio
                      label="Past One Year"
                      value="Past One Year"
                      color="lime"
                    ></v-radio>
                    <v-radio
                      label="Past 2 years"
                      value="Past 2 years"
                      color="lime"
                    ></v-radio>
                    <v-radio
                      label="More than three years ago"
                      value="More than three years ago"
                      color="lime"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <h4>If yes, who was the funding agency? Specify</h4>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.grant_funding_agency"
                    :error-messages="errors.grant_funding_agency"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <h4>
                    If the yes, was the grant won with multiple applicants?
                  </h4>
                </v-flex>
                <v-flex xs12 md12 v-if="register.grant_history == 'Yes'">
                  <v-radio-group
                    v-model="register.grant_applicants"
                    wrap
                    :error-messages="errors.grant_applicants"
                  >
                    <v-radio label="Yes" value="Yes" color="lime"></v-radio>
                    <v-radio label="No" value="No" color="lime"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>
                    If you were to be trained on grant writing, what areas would
                    be of interest? (Chose all that apply)
                  </h4>
                </v-flex>
                <v-alert :value="errors_training_interest" type="error">
                  Please answer the above question
                </v-alert>
                <v-flex xs12 md12>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Steps to developing a grant proposal"
                    value="Steps to developing a grant proposal"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="How to identify potential funding sources from common data bases"
                    value="How to identify potential funding sources from common data bases"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="How to read and understand grant guidelines, requests for proposals/applications (RFP/RFA)"
                    value="How to read and understand grant guidelines, requests for proposals/applications (RFP/RFA)"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Literature search for grant writing"
                    value="Literature search for grant writing"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Writing a concept note"
                    value="Writing a concept note"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Overview of study design"
                    value="Overview of study design"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Research probity"
                    value="Research probity"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Monitoring and evaluation "
                    value="Monitoring and evaluation "
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Developing a gnatt chart"
                    value="Developing a gnatt chart"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Writing research question/ aim and objectives"
                    value="Writing research question/ aim and objectives"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Preparation and justification of budgets"
                    value="Preparation and justification of budgets"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Protocols for use of animal and human subjects in research"
                    value="Protocols for use of animal and human subjects in research"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Cost-sharing and sub-contracts"
                    value="Cost-sharing and sub-contracts"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Procedures for grants submission and grants start-up"
                    value="Procedures for grants submission and grants start-up"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="The grant review process"
                    value="The grant review process"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Writing cover letters"
                    value="Writing cover letters"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="register.training_interest"
                    color="lime"
                    label="Preparing a curriculum vitae"
                    value="Preparing a curriculum vitae"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>Specify others if any</h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.training_interest_others"
                    :error-messages="errors.training_interest_others"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>
                    What are the 2 main obstacles you face when writing for
                    grants or what areas would you require capacity building to
                    be able to apply for grants?
                  </h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.grant_obstacles"
                    :error-messages="errors.grant_obstacles"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <h4>
                    What other funding agencies are you likely to apply to?
                  </h4>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    class="input-group--focused"
                    color="lime"
                    v-model="register.grant_agencies"
                    :error-messages="errors.grant_agencies"
                  ></v-text-field>
                </v-flex>
              </v-card-text>
            </v-card>
            <v-btn
              color="lime"
              class="white--text"
              @click.native="StepOne"
              v-if="disabled == false"
              >submit</v-btn
            >
            <v-btn disabled v-if="disabled == true">
              <v-progress-circular
                :width="3"
                :size="15"
                indeterminate
                color="white"
              ></v-progress-circular
              >&nbsp; submitting
            </v-btn>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Processing
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Vue from "vue"
import { grant_writing_needs_assessment_Url } from "@/config"
import axios from "axios"
import swal from "sweetalert2"
export default {
  data() {
    return {
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      e1: 0,
      e6: 1,
      disabled: false,
      step_one: true,
      downloaded: false,
      register: {
        name: "",
        email: "",
        grant_history: "",
        training_interest: [],
        grant_obstacles: "",
        grant_number: "",
        grant_agencies: "",
        grant_last: "",
        grant_applicants: "",
        grant_funding_agency: ""
      },
      errors: {
        name: "",
        email: "",
        grant_history: "",
        grant_obstacles: "",
        grant_number: "",
        grant_agencies: "",
        grant_last: "",
        grant_applicants: "",
        grant_funding_agency: ""
      },
      errors_training_interest: false,
      series: [
        /*{
          id: 1,
          name: "November 2nd-13th 2020 {Day Class Schedule}"
        },
        {
          id: 2,
          name: "November 2nd-27th 2020 {Evening Class Schedule} "
        },
        {
          id: 3,
          name: "April 2021 {Day Class Schedule} "
        },
        {
          id: 4,
          name: "April 2021 {Evening Class Schedule} "
        },*/
        {
          id: 5,
          name: "August 2021 {Evening Class Schedule} "
        }
      ],
      dialog: false
    }
  },
  beforeMount() {
    //this.downloaded = true
    //this.fetchData()
    this.dialog = false
  },
  /*beforeRouteLeave(to, from, next) {
    if (!window.setIntervalConfirm) {
      next()
    } else {
      clearInterval(setIntervalConfirm)
      next()
    }
  },
  mounted() {
    var counter = 0
    var vm = this
    window.setIntervalConfirm = setInterval(function() {
      counter += 1

      if (!vm.training_institutions.length) {
        vm.fetchData()
      }

      if (counter === 3) {
        clearInterval(setIntervalConfirm)
      }
    }, 60000)
  },*/
  methods: {
    StepOne() {
      var vm = this
      vm.disabled = true
      if (
        vm.register.name == "" ||
        vm.register.email == "" ||
        vm.register.grant_history == "" ||
        vm.register.training_interest == "" ||
        vm.register.grant_obstacles == "" ||
        vm.register.grant_agencies == ""
      ) {
        if (vm.register.name == "") {
          vm.errors.name = "Please answer the above question"
        } else {
          vm.errors.name = ""
        }
        if (vm.register.email == "") {
          vm.errors.email = "Please answer the above question"
        } else {
          vm.errors.email = ""
        }
        if (vm.register.grant_history == "") {
          vm.errors.grant_history = "Please answer the above question"
        } else {
          vm.errors.grant_history = ""
        }
        if (vm.register.training_interest == "") {
          vm.errors_training_interest = true
        } else {
          vm.errors_training_interest = false
        }
        if (vm.register.grant_obstacles == "") {
          vm.errors.grant_obstacles = "Please answer the above question"
        } else {
          vm.errors.grant_obstacles = ""
        }
        if (vm.register.grant_agencies == "") {
          vm.errors.grant_agencies = "Please answer the above question"
        } else {
          vm.errors.grant_agencies = ""
        }
        vm.step_one = false
        vm.disabled = false
      } else {
        if (vm.register.grant_history == "Yes") {
          if (
            vm.register.grant_applicants == "" ||
            vm.register.grant_funding_agency == "" ||
            vm.register.grant_last == "" ||
            vm.register.grant_number == ""
          ) {
            if (vm.register.grant_number == "") {
              vm.errors.grant_number = "Please answer the above question"
            } else {
              vm.errors.grant_number = ""
            }
            if (vm.register.grant_last == "") {
              vm.errors.grant_last = "Please answer the above question"
            } else {
              vm.errors.grant_last = ""
            }
            if (vm.register.grant_funding_agency == "") {
              vm.errors.grant_funding_agency =
                "Please answer the above question"
            } else {
              vm.errors.grant_funding_agency = ""
            }
            if (vm.register.grant_applicants == "") {
              vm.errors.grant_applicants = "Please answer the above question"
            } else {
              vm.errors.grant_applicants = ""
            }
            vm.step_one = false
            vm.disabled = false
          } else {
            vm.errors.name = ""
            vm.errors.email = ""
            vm.errors.grant_history = ""
            vm.errors_training_interest = false
            vm.errors.grant_number = ""
            vm.errors.grant_agencies = ""
            vm.errors.grant_last = ""
            vm.errors.grant_applicants = ""
            vm.errors.grant_funding_agency = ""
            vm.step_one = true
            //vm.disabled = false
            vm.submit()
          }
        } else {
          vm.errors.name = ""
          vm.errors.email = ""
          vm.errors.grant_history = ""
          vm.errors_training_interest = false
          vm.errors.grant_number = ""
          vm.errors.grant_agencies = ""
          vm.errors.grant_last = ""
          vm.errors.grant_applicants = ""
          vm.errors.grant_funding_agency = ""
          vm.step_one = true
          //vm.disabled = false
          vm.submit()
        }
      }
    },
    submit() {
      var vm = this
      vm.downloaded = true
      const data = {
        name: vm.register.name,
        email: vm.register.email,
        grant_history: vm.register.grant_history,
        training_interest: vm.register.training_interest,
        grant_obstacles: vm.register.grant_obstacles,
        grant_number: vm.register.grant_number,
        grant_agencies: vm.register.grant_agencies,
        grant_last: vm.register.grant_last,
        grant_applicants: vm.register.grant_applicants,
        grant_funding_agency: vm.register.grant_funding_agency
      }

      axios
        .post(grant_writing_needs_assessment_Url, data)
        .then(function(response) {
          if (response.data.stored) {
            vm.e1 = 1
            vm.dialog = true
            swal({
              title: "Submitted",
              text: "Your application was submitted successfully",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            //vm.$router.push({ name: "register" })
            vm.disabled = false
            vm.register.name = ""
            vm.register.email = ""
            vm.register.grant_history = ""
            vm.register.training_interest = []
            vm.register.grant_obstacles = ""
            vm.register.grant_number = ""
            vm.register.grant_agencies = ""
            vm.register.grant_last = ""
            vm.register.grant_applicants = ""
            vm.register.grant_funding_agency = ""
          } else {
            swal({
              title: "Failed",
              text: "Please contact KNDI through atri@kndi.institute",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.disabled = false
            vm.downloaded = false
          }
        })
        .catch(function(error) {
          console.log(error)
          Vue.set(vm.$data, "errors", error.response.data)
          vm.disabled = false
          vm.downloaded = false
          vm.step_one = false
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/public/grant-writing-needs-assessment.vue